import React from 'react';

export const ExcellentRatingIcon = ({ borderClass }: { borderClass?: string }) => {
    return (
        <span className={borderClass}>
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="none">
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M27 15H27.02M15 15H15.02M41 21C41 32.0457 32.0457 41 21 41C9.9543 41 1 32.0457 1 21C1 9.9543 9.9543 1 21 1C32.0457 1 41 9.9543 41 21ZM28 15C28 15.5523 27.5523 16 27 16C26.4477 16 26 15.5523 26 15C26 14.4477 26.4477 14 27 14C27.5523 14 28 14.4477 28 15ZM16 15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15C14 14.4477 14.4477 14 15 14C15.5523 14 16 14.4477 16 15ZM21 32C26.001 32 30 28.334 30 25H12C12 28.334 15.999 32 21 32Z"
                    stroke="#0070C8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};
